import { apiClient } from "./apiClient";

export interface WordConfidence {
  word: string;
  confidence: number;
  start?: number | null;
  end?: number | null;
}

export interface TranscribeResponse {
  text: string;
  provider: string;
  model: string;
  confidence: number | null;
  language: string | null;
  duration_seconds: number | null;
  cost_usd: number | null;
  latency_ms: number | null;
  input_tokens: number | null;
  output_tokens: number | null;
  total_tokens: number | null;
  low_confidence_words: string[];
  words: WordConfidence[];
}

export interface TranscribeResult {
  data: TranscribeResponse;
  /** Full round trip measured client-side (includes network) — always available, unlike server latency_ms. */
  clientLatencyMs: number;
}

/**
 * POST an audio blob to /api/v1/stt/transcribe. Requires an authenticated
 * session (apiClient attaches the bearer token automatically).
 */
export async function transcribeAudio(
  audioBlob: Blob,
  opts: { language?: string; includeWords?: boolean } = {},
): Promise<TranscribeResult> {
  const form = new FormData();
  const ext = audioBlob.type.includes("mp4") ? "mp4" : audioBlob.type.includes("mpeg") ? "mp3" : "webm";
  form.append("file", audioBlob, `voice.${ext}`);

  const params: Record<string, string> = {};
  if (opts.language) params.language = opts.language;
  if (opts.includeWords) params.include_words = "true";

  const started = performance.now();
  const resp = await apiClient.post<TranscribeResponse>("/api/v1/stt/transcribe", form, {
    params,
    headers: { "Content-Type": "multipart/form-data" },
  });
  const clientLatencyMs = Math.round(performance.now() - started);

  return { data: resp.data, clientLatencyMs };
}
